import { useTranslation } from 'react-i18next';
import {
  Button,
  Icon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@kognitos/lattice';

/** Swaps the rail between its two widths. */
export function RailWidthToggle({
  isCollapsed,
  onToggle,
}: {
  isCollapsed: boolean;
  onToggle: () => void;
}) {
  const { t: tAutomation } = useTranslation('automation');
  const label = tAutomation(
    isCollapsed
      ? 'automation.draftRail.expand'
      : 'automation.draftRail.collapse',
  );

  return (
    <Tooltip delayDuration={200} variant="primary">
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="secondary"
          size="icon-sm"
          onClick={onToggle}
          aria-label={label}
          aria-expanded={!isCollapsed}
          data-testid="draft-rail-width-toggle"
        >
          <Icon type={isCollapsed ? 'ChevronLeft' : 'ChevronRight'} size="xs" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
